/**
 * Deserialize HTML text node to text.
 */
function deserializeHTMLToText({
  node,
  plugins
}) {
  let text;
  plugins.some(({
    deserialize: pluginDeserializers
  }) => {
    if (!(pluginDeserializers !== null && pluginDeserializers !== void 0 && pluginDeserializers.text)) {
      return false;
    }
    return pluginDeserializers.text.some(deserializer => {
      const deserialized = deserializer.deserialize(node);
      if (!deserialized) {
        return false;
      }
      text = deserialized;
      return true;
    });
  });
  if (text != null) {
    return text;
  }
  if (node.nodeType === Node.TEXT_NODE) {
    return node.textContent;
  }
  return undefined;
}

export { deserializeHTMLToText };
